import React from 'react';
import { css } from '@emotion/react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const ContentContainer = css`
  width: 480px;
  margin-bottom: 24px;
`;

export const CareRecordMemoSection = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={ContentContainer}>
      <TextField
        id='care-record-memo-field'
        label={t('memo', 'メモ')}
        value={form.memo ?? ''}
        onChange={form.handleChangeMemo}
        multiline={true}
        minRows={3}
        fullWidth={true}
      />
    </div>
  );
};
